import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createBlock as _createBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  "txt-center": ""
}
const _hoisted_2 = {
  "txt-center": "",
  style: {"min-height":"60px","padding":"10px 20px"}
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 0,
  "m-b-2": "",
  style: {"max-width":"400px","margin-left":"auto !important","margin-right":"auto !important"}
}
const _hoisted_6 = {
  key: 0,
  "txt-center": ""
}
const _hoisted_7 = {
  key: 0,
  "m-b-1": ""
}
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { key: 2 }
const _hoisted_11 = { key: 2 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { "txt-center": "" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_image = _resolveComponent("el-image")!
  const _component_app_bidding_profile_modal = _resolveComponent("app-bidding-profile-modal")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_slider = _resolveComponent("el-slider")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_space = _resolveComponent("el-space")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    "custom-class": "App-Create-Bidding-Modal App-Unpadded",
    "model-value": _ctx.isModalOpen,
    width: "550px",
    "show-close": _ctx.showClose,
    onOpen: _ctx.opened,
    onClose: _ctx.closeModal,
    title: !_ctx.sentBidding ? 'Send Bidding' : '',
    center: "",
    "close-on-click-modal": false,
    "append-to-body": true,
    "lock-scroll": true,
    "open-delay": 200,
    "close-delay": 200
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_13, [
        (_ctx.hasAlreadyBidded === false && !_ctx.sentBidding)
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              "is-block": "",
              icon: "el-icon-position",
              onClick: _ctx.submit,
              size: "large",
              type: "primary",
              disabled: _ctx.disabledSave || _ctx.loading
            }, {
              default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                _createTextVNode(" Send Bidding ", -1)
              ]))]),
              _: 1
            }, 8, ["onClick", "disabled"]))
          : _createCommentVNode("", true)
      ])
    ]),
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createElementBlock("div", null, [
        (_ctx.sentBidding)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_el_image, {
                  style: `width: 160px;`,
                  src: _ctx.img
                }, null, 8, ["src"])
              ]),
              _cache[8] || (_cache[8] = _createElementVNode("h2", { "txt-center": "" }, "Sent the offer!", -1)),
              _cache[9] || (_cache[9] = _createElementVNode("p", null, [
                _createTextVNode(" Look out in your inbox for any response "),
                _createElementVNode("br"),
                _createTextVNode(" from the talent. ")
              ], -1))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_3, [
              (_ctx.hasAlreadyBidded === false)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createVNode(_component_el_form, {
                      onSubmit: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["prevent"])),
                      class: "App-Styled-Form",
                      "label-position": 'top',
                      "label-width": "100px",
                      model: _ctx.form,
                      style: {"margin-top":"12px"},
                      rules: _ctx.rules
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_app_bidding_profile_modal, {
                          opportunity: _ctx.opportunity,
                          talent: _ctx.talent
                        }, null, 8, ["opportunity", "talent"]),
                        _createVNode(_component_el_form_item, {
                          prop: "compensationTypes",
                          label: "How are you willing to compensate the talent?"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_select, {
                              multiple: "",
                              modelValue: _ctx.form.compensationTypes,
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.compensationTypes) = $event)),
                              placeholder: "Compensation Type",
                              onChange: _ctx.change,
                              "w-100": ""
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_option, {
                                  value: 'cash',
                                  label: 'Cash'
                                }),
                                _createVNode(_component_el_option, {
                                  value: 'equity',
                                  label: 'Equity'
                                })
                              ]),
                              _: 1
                            }, 8, ["modelValue", "onChange"])
                          ]),
                          _: 1
                        }),
                        (_ctx.hasAllTypes)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                              _createVNode(_component_el_slider, {
                                modelValue: _ctx.equityDistribution,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.equityDistribution) = $event)),
                                min: 0,
                                max: 100,
                                marks: _ctx.marks
                              }, null, 8, ["modelValue", "marks"])
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", null, [
                          (_ctx.form.compensationTypes.length > 0)
                            ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_6, [
                                (_ctx.compensationPrediction)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                      _cache[12] || (_cache[12] = _createElementVNode("h4", { "m-tb-0": "" }, "Proposed Compensation", -1)),
                                      _createVNode(_component_el_tooltip, {
                                        content: `For ${_ctx.$filters.boost(
                      _ctx.compensationPrediction.boost
                    )}`
                                      }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("div", null, [
                                            (_ctx.form.compensationTypes.includes('equity'))
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_8, [
                                                  _createTextVNode(_toDisplayString(_ctx.equityPredicted.toFixed(3)) + "% ", 1),
                                                  _cache[10] || (_cache[10] = _createElementVNode("span", null, " Equity", -1))
                                                ]))
                                              : _createCommentVNode("", true),
                                            (_ctx.hasAllTypes)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_9, "or"))
                                              : _createCommentVNode("", true),
                                            (_ctx.form.compensationTypes.includes('cash'))
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_10, [
                                                  _createElementVNode("span", null, " $ " + _toDisplayString(_ctx.$filters.number(_ctx.cashPredicted)), 1),
                                                  _cache[11] || (_cache[11] = _createElementVNode("span", null, " Cash", -1))
                                                ]))
                                              : _createCommentVNode("", true)
                                          ])
                                        ]),
                                        _: 1
                                      }, 8, ["content"]),
                                      _createVNode(_component_el_divider)
                                    ]))
                                  : _createCommentVNode("", true)
                              ])), [
                                [_directive_loading, _ctx.loadingCompensation]
                              ])
                            : _createCommentVNode("", true)
                        ]),
                        (_ctx.form.compensationTypes.includes('equity'))
                          ? (_openBlock(), _createBlock(_component_el_form_item, {
                              key: 1,
                              prop: "equity",
                              label: "How much equity? In % (Percentages)."
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_input_number, {
                                  "w-100": "",
                                  min: 0,
                                  max: 100,
                                  controls: false,
                                  placeholder: "EX: 5",
                                  modelValue: _ctx.form.equity,
                                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.equity) = $event))
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true),
                        (_ctx.form.compensationTypes.includes('cash'))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                              _createVNode(_component_el_space, {
                                size: 16,
                                "w-100": ""
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_form_item, {
                                    prop: "currency",
                                    label: "Currency"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_select, {
                                        prop: "currency",
                                        modelValue: _ctx.form.currency,
                                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.currency) = $event)),
                                        placeholder: "Currency",
                                        style: {"width":"100%"}
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_el_option, {
                                            label: "£ (Pound)",
                                            value: "gbp"
                                          }),
                                          _createVNode(_component_el_option, {
                                            label: "$ (US Dollars)",
                                            value: "usd"
                                          }),
                                          _createVNode(_component_el_option, {
                                            label: "€ (Euros)",
                                            value: "euro"
                                          })
                                        ]),
                                        _: 1
                                      }, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_form_item, {
                                    prop: "cash",
                                    label: "Compensation Cash?"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_input_number, {
                                        style: {"width":"100%"},
                                        controls: false,
                                        placeholder: "200,000",
                                        modelValue: _ctx.form.cash,
                                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.cash) = $event))
                                      }, null, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]))
                          : _createCommentVNode("", true),
                        _createVNode(_component_el_divider),
                        _createVNode(_component_el_form_item, {
                          prop: "expireAt",
                          label: "Expiration Date"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_date_picker, {
                              format: "DD/MM/YYYY",
                              type: "date",
                              placeholder: "DD/MM/YYYY",
                              modelValue: _ctx.form.expireAt,
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.expireAt) = $event))
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, {
                          prop: "description",
                          label: "Add your offer"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              rows: "5",
                              type: "textarea",
                              placeholder: "Description",
                              modelValue: _ctx.form.description,
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.description) = $event))
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["model", "rules"])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.hasAlreadyBidded === true)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [...(_cache[13] || (_cache[13] = [
                    _createElementVNode("h2", { "txt-center": "" }, "Oops!", -1),
                    _createElementVNode("p", {
                      "txt-center": "",
                      "m-tb-0": ""
                    }, [
                      _createTextVNode(" You have already placed a bid for "),
                      _createElementVNode("br"),
                      _createTextVNode(" this talent on this same opportunity. "),
                      _createElementVNode("br"),
                      _createTextVNode(" Check your email inbox for any response from the talent if any. ")
                    ], -1)
                  ]))]))
                : _createCommentVNode("", true)
            ]))
      ])), [
        [_directive_loading, _ctx.loading]
      ])
    ]),
    _: 1
  }, 8, ["model-value", "show-close", "onOpen", "onClose", "title"]))
}